const points = [
  [ -9, 0 ],
  [ -9, 8 ],
  [ -7, 10 ],
  [ -3, 10 ],
  [ -3, 16 ],
  [ 3, 16 ],
  [ 3, 10 ],
  [ 7, 10 ],
  [ 9, 8 ],
  [ 9, 0 ],
  [ 9, -8 ],
  [ 6, -14 ],
  [ -6, -14 ],
  [ -9, -8 ],
  [ -9, 0 ]
]

export default points
